<!-- PCB订单备注 -->
<template>
  <BaseFormItem2
    class="note"
    :label="fields.label"
  >
    <BaseInput2
      v-model="val"
      class="note__input"
      type="textarea"
      autosize
      placeholder="Pads软件默认铺铜方式为Hatch，如用其他方式请备注说明，以免出现生产问题"
      @input="handleEmit"
    />
    <p class="note__tips">* 请不要将板子或钢网的加工要求填写在这</p>
    <p v-if="isShowGchTips" class="note__gchTips">录入订单备注，暂不支持优惠工程费，已恢复原价</p>
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    // 是否显示工程费提示
    isShowGchTips: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getFR4Fields('note')
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.note {
  ::v-deep {
    .base-form-item__content {
      flex: 1;
    }
  }
  .note__input {
    width: calc(100% - 100px) !important;
  }
  .note__tips {
    margin-top: 4px;
    line-height: 1.5;
    font-size: $--font-size-small;
    color: $--color-warning;
  }
  .note__gchTips {
    margin-left: 8px;
    line-height: 1.5;
    font-size: $--font-size-small;
    color: #D9001B;
  }
}
</style>